import { render } from "./Capricorn.vue?vue&type=template&id=69c219bc&scoped=true"
import script from "./Capricorn.vue?vue&type=script&lang=js"
export * from "./Capricorn.vue?vue&type=script&lang=js"

import "./Capricorn.vue?vue&type=style&index=0&id=69c219bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69c219bc"]])

export default __exports__